export class Agency {
  public id?: string;
  public code?: string = '';
  public manageCompanyId?: string = '';
  public manageCompanyName?: string = '';
  public warehouseId?: string = '';
  public name?: string = '';
  public closingDate?: number = 0;
  public fee?: number;
  public extensionFee?: number;
  public btjCompanyId?: string;
  public saleOfficeId?: string;
  // Contact
  public picName?: string = '';
  public phoneNumber?: string = '';
  public postalCode?: string = '';
  public address1?: string = '';
  public address2?: string = '';
  // Account
  public accountId?: string = '';
  public accountUsername?: string = '';
  public accountEmail?: string = '';
  public accountPassword?: string = '';

  constructor(init?: Partial<Agency>) {
    Object.assign(this, init);
  }
}
